import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
} from "@angular/core";
import {
  FormArray,
  FormControl,
} from "@angular/forms";
import { Subject } from "rxjs";
import { take } from "rxjs/operators";
import {
  SharedModule,
  FormInputComponent,
  RelationCustomFieldConfig,
  ModalService,
} from "@bb-vendure/admin-ui/core";
import SelectZoneModalComponent from "../FanClubLink/LinkDetailNg/select-zone-modal/select.component";

type InputListItem = {
  id: number;
  // componentRef?: ComponentRef<FormInputComponent>;
  // control: UntypedFormControl;
};

@Component({
  imports: [SharedModule],
  standalone: true,
  templateUrl: "./country-shipping-method-list.component.html",
  styleUrl: "./country-shipping-method-list.component.scss",
})
export class CountryShippingMethodListComponent
  implements OnInit, FormInputComponent<RelationCustomFieldConfig>
{
  listItems: any[] = [];
  private renderList$ = new Subject<any[]>();
  private listFormArray = new FormArray([] as Array<FormControl<any>>);
  private listId = 1;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private injector: Injector,
    private modalService: ModalService
  ) {}

  ngOnInit(): void {
    console.log(this.formControl);

    if (this.formControl.value) {
      for (const c of this.formControl.value) {
        this.listItems.push({
          id: c.id,
          code: c.code,
          name: c.name,
        });
      }
    } else {
      this.formControl.patchValue([]);
    }
  }
  isListInput?: boolean | undefined = true;
  readonly: boolean;
  formControl: FormControl<any>;
  config: RelationCustomFieldConfig;

  trackById(index: number, item: { id: number }) {
    return item.id;
  }

  moveListItem(event: CdkDragDrop<InputListItem>) {
    if (this.listItems) {
      moveItemInArray(this.listItems, event.previousIndex, event.currentIndex);
    }
  }

  removeListItem(item: InputListItem) {
    if (this.listItems) {
      const index = this.formControl.value.findIndex((i) => i === item);
      this.listFormArray.removeAt(index);
      this.listItems = this.listItems.filter((i) => i !== item);
      this.formControl.patchValue(this.listItems.filter((i) => i !== item));

      this.formControl.markAsDirty();
    }
  }

  addListItem() {
    if (!this.listItems) {
      this.listItems = [];
    }

    this.modalService
      .fromComponent(SelectZoneModalComponent, {
        size: "lg",
        closable: true,
      })
      .pipe(take(1))
      .subscribe((z) => {
        if (z) {
          const countries = z.members;

          for (const c of countries) {
            if (!this.listItems.find((i) => i.id === c.id)) {
              const data = c;
              this.listItems.push(data);

              this.formControl.patchValue([...this.formControl.value, data]);
            }
          }

          this.formControl.markAsDirty();
        }
      });

    // this.listItems.push({
    //   id: this.listId++,
    // });
    //this.renderList$.next();
  }
}
